import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const SMSClick = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.16725 15.925L3.8125 18.4375V15.0625H2.6875C2.38913 15.0625 2.10298 14.944 1.892 14.733C1.68103 14.522 1.5625 14.2359 1.5625 13.9375V2.6875C1.5625 2.38913 1.68103 2.10298 1.892 1.892C2.10298 1.68103 2.38913 1.5625 2.6875 1.5625H17.3125C17.6109 1.5625 17.897 1.68103 18.108 1.892C18.319 2.10298 18.4375 2.38913 18.4375 2.6875V8.3125"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.90203 9.67619L10.912 16.3744C10.9429 16.4777 11.0001 16.5711 11.0779 16.6456C11.1557 16.7201 11.2515 16.7731 11.356 16.7995C11.4604 16.8259 11.57 16.8247 11.6738 16.7961C11.7777 16.7675 11.8723 16.7124 11.9485 16.6362L12.9723 15.6124L15.6138 18.2539C15.6716 18.3118 15.7402 18.3576 15.8158 18.3889C15.8913 18.4202 15.9723 18.4363 16.054 18.4363C16.1358 18.4363 16.2168 18.4202 16.2923 18.3889C16.3678 18.3576 16.4365 18.3118 16.4943 18.2539L18.2553 16.4929C18.3131 16.4351 18.359 16.3665 18.3903 16.291C18.4216 16.2154 18.4377 16.1345 18.4377 16.0527C18.4377 15.9709 18.4216 15.89 18.3903 15.8144C18.359 15.7389 18.3131 15.6702 18.2553 15.6124L15.6138 12.9709L16.6375 11.9502C16.7137 11.8741 16.7688 11.7794 16.7975 11.6756C16.8262 11.5718 16.8274 11.4623 16.8011 11.3579C16.7748 11.2534 16.7219 11.1576 16.6475 11.0797C16.573 11.0019 16.4797 10.9447 16.3765 10.9137L9.67753 8.90369C9.57014 8.87182 9.45614 8.86948 9.34753 8.89692C9.23892 8.92436 9.13972 8.98056 9.06035 9.05962C8.98099 9.13868 8.9244 9.23767 8.89654 9.34617C8.86868 9.45467 8.87057 9.56867 8.90203 9.67619V9.67619Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
